import { useTranslation } from 'react-i18next';
import { ErrMessageKeys, validateEmail, validateName, ValidationRules } from '@myme/utils';

export interface UpdateUserPersonalInfoFormValues {
  email: string;
  firstName: string;
  lastName: string;
  displayName: string;
}

export const useEditPersonalInfoForm = () => {
  const { t } = useTranslation();

  const validationRules: ValidationRules = {
    email: { required: true, validate: value => validateEmail(value as string) },
    firstName: { required: true, validate: value => validateName(value as string) },
    lastName: { required: true, validate: value => validateName(value as string) }
  };

  const errorMessageKeys: ErrMessageKeys = {
    email: t('errors.validation.email_incorrect'),
    firstName: t('errors.validation.first_name'),
    lastName: t('errors.validation.last_name')
  };

  return {
    rules: validationRules,
    errMessage: errorMessageKeys
  };
};

export interface UpdateUserEmailFormValues {
  currentEmail: string;
  newEmail: string;
  newEmailConfirm: string;
}

export const useEditEmailForm = (currentEmail: string, newEmail: string) => {
  const { t } = useTranslation();

  const validationRules: ValidationRules = {
    currentEmail: {
      required: true,
      validate: value => validateEmail(value as string) && value.toString().toLowerCase() === currentEmail.toLowerCase()
    },
    newEmail: { required: true, validate: value => validateEmail(value as string) },
    newEmailConfirm: { required: true, validate: value => (value as string).toLowerCase() === newEmail.toLowerCase() }
  };

  const errorMessageKeys: ErrMessageKeys = {
    currentEmail: t('errors.validation.email_current'),
    newEmail: t('errors.validation.email_new'),
    newEmailConfirm: t('errors.validation.email_new_confirm')
  };

  return {
    rules: validationRules,
    errMessage: errorMessageKeys
  };
};
